module.exports = __webpack_public_path__ + "static/media/pie-chart.59625441.svg";